export const MINOR_UNITS_SCALE = 100

export const toMajorUnits = (value: number): number => {
    const numericValue = Number(value || 0)
    return numericValue / MINOR_UNITS_SCALE
}
